import { useFieldMetadata } from './useFieldMetadata';

export function useFieldTranslationKey(id: string): string {
  const metadata = useFieldMetadata(id);
  return metadata?.translationKey ?? id;
}
